import { render, staticRenderFns } from "./scanPacks.vue?vue&type=template&id=479d35f9"
import script from "./scanPacks.vue?vue&type=script&lang=js"
export * from "./scanPacks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports